import * as React from "react";
import { forwardRef } from "react";
const SvgCloseSquare = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3 3L13.3709 13.3709", stroke: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M3 13.371L13.3709 3.00007", stroke: "currentColor" }));
const ForwardRef = forwardRef(SvgCloseSquare);
export { ForwardRef as ReactComponent };
